import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestResponse } from '../../shared/model/rest-response';
import { RestService } from '../../shared/service/rest.service';
import { ServerSetting } from '../model/server-setting';

@Injectable({
  providedIn: 'root'
})
export class SettingsService extends RestService {

  getUserSettings(): Observable<RestResponse<ServerSetting>> {
    return this.postRequest<ServerSetting>(ServerSetting, 'api/settings/gwt/fetch');
  }

}
